<template>
  <div>
    <Card>
      <ui-create-url-tags
        :chips="chips"
        label="Test url"
        :showToolTip="false"
      ></ui-create-url-tags>
    </Card>
    <Card>
      <ui-create-url-tags
        :chips="chips"
        label="Test url"
        :showToolTip="true"
        :showQr="false"
      ></ui-create-url-tags>
    </Card>
    <Card>
      <ui-create-url-tags
        :disabled="true"
        :chips="chips"
        label="Test url"
        :showToolTip="true"
      ></ui-create-url-tags>
    </Card>
  </div>
</template>

<script setup lang="ts">
import Card from '@/stories/utils/card.vue';

const chips = [
  {
    tag: 'tag1',
    disabled: false,
  },
  {
    tag: 'tag2',
    disabled: true,
  },
  {
    tag: 'tag3',
    disabled: false,
  },
];
</script>
